import { Pipe, PipeTransform } from '@angular/core';
import { decode } from 'html-entities';

@Pipe({
    name: 'decodeHtmlEntities',
    standalone: false,
})
export class DecodeHtmlEntitiesPipe implements PipeTransform {
    transform(value: string): any {
        return decode(value);
    }
}
